module.exports = __webpack_public_path__ + "img/guagua_icon.e5e0e2f4.png";